import { Pipe, PipeTransform } from '@angular/core';

interface IClient {
  idcliente: number,
  nome: string;
  email: string;
  cpfcnpj: string;
  telefone: string;
  password: string;
  canais: number;
  mensagens: number;
  nutricoes: number;
  host: string;
  revendedor: string;
  status: string;
}
@Pipe({
  name: 'clientFilterName',
  standalone: true
})
export class ClientPipe implements PipeTransform {

  transform(arrayClients: Array<IClient>, filterName: string): any {
    if(arrayClients.length === 0 || !filterName){ 
      return arrayClients;
    }else {
      const newArray: Array<IClient> = arrayClients.filter(element => element.nome.toLowerCase().includes(filterName.toLowerCase()) || element.email.toLowerCase().includes(filterName.toLowerCase()));
      return newArray;
    }
  }

}


@Pipe({
  name: 'clientFilterStatus',
  standalone: true
})
export class ClientPipeStatus implements PipeTransform {

  transform(arrayClients: Array<IClient>, filterStatus: "TODOS"|"ATIVO" | "INATIVO"): any {
    if(arrayClients.length === 0 || !filterStatus){ 
      return arrayClients;
    }else if(filterStatus === "TODOS"){
      return arrayClients;
    }
    else{
      const newArray: Array<IClient> = arrayClients.filter(element => element.status === filterStatus);
      return newArray;
    }
  }

}
